import { useContext } from "react";
import IconeWithText from "../Compo/IconeWithText";
import { GVarState } from "../StoreState/Gstate";

function StepByStepMobile() {
    let g = useContext(GVarState);


    // return null

    return (
        <div className='stapebystapeMo'>
            <div className='flex items-center justify-center w-full flex-col ' >
                {/* <span><ShowUpdate /></span> */}
                <img src="/images/upgo.png" className="UpImage" onClick={() => {
                    if (document.querySelector(".stapechilderMo")) {
                        if (document.querySelector(".stapechilderMo").style.height == "50vh") {
                            document.querySelector(".UpImage").style.transform = "rotate(0deg)"
                            document.querySelector(".stapechilderMo").style.height = "0px"
                        } else {
                            document.querySelector(".UpImage").style.transform = "rotate(180deg)"
                            document.querySelector(".stapechilderMo").style.height = "50vh"
                        }
                    }

                }} />
                <span>Step-by-step directions</span>
                {/* <span><StepArrow /></span> */}
            </div>
            <div className="stapechilderMo">
                {g.StapeByStape?.map((d, i) => {
                    return <IconeWithText
                        text={d.text}
                        distance={`${d.dist.toFixed(2)}m`}
                        d={d}
                        i={i}
                    />
                })}
            </div>
        </div>
    )
}
export default StepByStepMobile

function StepArrow() {
    return <svg width="20" height="20" viewBox="0 -5 40 40"><g fill="#606060" stroke="#606060"><path stroke="none" d="M17.1425009 30.7692308c-.7188906.679735-1.8844424.679735-2.603333 0-.7188905-.6797351-.7188905-1.7818034 0-2.4615385L25.443 17.9980321l-22.6795229-.053603c-.9295336-.0022012-1.6899275-.8049029-1.7584527-1.8222573L1 15.968032C1.002075 14.8788093 1.7949665 13.9976933 2.7709767 14L25.498 14.0540321 14.5391679 3.6923077c-.6789522-.641972-.7166717-1.6606549-.1131587-2.3444836l.1131587-.1170549c.7188906-.679735 1.8844424-.679735 2.603333 0l14.3183312 13.5384616c.7188905.679735.7188905 1.7818034 0 2.4615384z"></path></g></svg>
}
function ShowUpdate() {
    return <svg width="20" height="20" viewBox="0 0 26 26"><g fill="#606060" stroke="#606060"><path stroke="none" d="M21.2216186 0C22.6456193 0 23.8 1.1654805 23.8 2.6031736v20.7936529C23.8 24.8345195 22.6456193 26 21.2216186 26H5.5783814C4.1543807 26 3 24.8345195 3 23.3968265V2.6031735C3 1.1654806 4.1543807 0 5.5783814 0h15.6432372zm0 2.6031736H5.5783814v20.7936529h15.6432372V2.6031735zM8.4476191 17.65625c.8205373 0 1.4857142.6715729 1.4857142 1.5s-.665177 1.5-1.4857142 1.5c-.8205374 0-1.4857143-.6715729-1.4857143-1.5s.665177-1.5 1.4857143-1.5zm10.1409528.2504767c.6900927 0 1.2495233.5594306 1.2495233 1.2495233 0 .6900927-.5594306 1.2495233-1.2495233 1.2495233H13.163809c-.6900926 0-1.2495233-.5594306-1.2495233-1.2495233 0-.6900927.5594307-1.2495233 1.2495233-1.2495233h5.4247629zM8.447619 11.5c.8205374 0 1.4857143.6715729 1.4857143 1.5s-.665177 1.5-1.4857142 1.5c-.8205374 0-1.4857143-.6715729-1.4857143-1.5s.665177-1.5 1.4857143-1.5zm10.273152.25c.690356 0 1.25.5596441 1.25 1.25s-.559644 1.25-1.25 1.25h-5.8028107c-.690356 0-1.25-.5596441-1.25-1.25s.559644-1.25 1.25-1.25h5.8028107zM8.447619 5.34375c.8205374 0 1.4857143.6715729 1.4857143 1.5s-.665177 1.5-1.4857142 1.5c-.8205374 0-1.4857143-.6715729-1.4857143-1.5s.665177-1.5 1.4857143-1.5zm10.2722143.25c.6903559 0 1.25.559644 1.25 1.25s-.5596441 1.25-1.25 1.25h-5.8028108c-.6903559 0-1.25-.559644-1.25-1.25s.5596441-1.25 1.25-1.25h5.8028108z"></path></g></svg>
}